import type { ListResponse, ObjectResponse } from '../../../common/types';
import type { QueueDropdownResponse } from '../../../features/workspace-common/types/responseTypes';
import { annotationToolApiV1, getAnnotationToolBasePath } from '../../../lib';
import { SUPERVISOR_PROJECTS_TAG } from '../constants';
import type {
    SupervisorProjectDetailsResponse,
    SupervisorProjectResponse,
    SupervisorProjectSummary,
} from '../types/response';

export const supervisorProjectsApiSlice = annotationToolApiV1
  .enhanceEndpoints({
    addTagTypes: [SUPERVISOR_PROJECTS_TAG],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getSupervisorProjectDetails: builder.query<ListResponse<SupervisorProjectResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;

          return `${tempPath}/projects/supervisor-projects/details`;
        },
        providesTags: [SUPERVISOR_PROJECTS_TAG],
      }),

      getSupervisorProjectsSummary: builder.query<ObjectResponse<SupervisorProjectSummary>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;
          return `${tempPath}/projects/supervisor-projects/summary`;
        },
        providesTags: [SUPERVISOR_PROJECTS_TAG],
      }),

      getSupervisorProjectById: builder.query<
        ObjectResponse<SupervisorProjectDetailsResponse>,
        { projectId: string }
      >({
        query: ({ projectId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;
          return `${tempPath}/projects/supervisor-projects/${projectId}`;
        },
        providesTags: [SUPERVISOR_PROJECTS_TAG],
      }),

      getAllocatedSupervisorProjects: builder.query<ListResponse<QueueDropdownResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;
          return `${tempPath}/projects/annotator-projects`;
        },
        providesTags: [SUPERVISOR_PROJECTS_TAG],
      }),
    }),
  });

export const {
  useGetSupervisorProjectDetailsQuery,
  useGetSupervisorProjectsSummaryQuery,
  useGetSupervisorProjectByIdQuery,
  useGetAllocatedSupervisorProjectsQuery,
} = supervisorProjectsApiSlice;
